const initNewsListWithPagination = () => {
  const showroom = document.querySelector('.km_news-list');
  if (!showroom) {
    return;
  }

  const newsCards = Array.from(showroom.querySelectorAll('.km_news-card-wrapper'));
  const itemsPerPage = showroom.dataset.pagination ? parseInt(showroom.dataset.pagination, 10) : 16; // Anzahl der Bilder pro Seite
  let currentPage = 1;
  const loadCards = (page, count, cats) => {
    const start = (page - 1) * count;
    const selectedCards = cats.length > 0
      ? newsCards.filter(ele => cats.includes(ele.dataset.filter))
      : newsCards;

    // Alle Bilder verstecken
    newsCards.forEach(imageLink => imageLink.classList.add('km_hidden'));

    // Bilder für die aktuelle Seite anzeigen
    selectedCards.slice(start, start + count).forEach(imageLink => {
      imageLink.classList.remove('km_hidden');
    });

    renderPagination(selectedCards.length, count, page);
  };

  const renderPagination = (totalItems, itemsPerPage, currentPage) => {
    const paginationContainer = document.getElementById('newsListPagination');
    paginationContainer.innerHTML = '';
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    if (totalPages <= 1) {
      paginationContainer.style.display = 'none';
      return;
    }else{
      paginationContainer.style.display = 'flex';
    }
    paginationContainer.style.display = '';
    for (let i = 1; i <= totalPages; i++) {
      const pageLink = document.createElement('button');
      pageLink.textContent = i;
      pageLink.classList.add('km_pagination-link', 'btn');
      if (i === currentPage) {
        pageLink.classList.add('active');
      }
      pageLink.addEventListener('click', (e) => {
        e.preventDefault();
        currentPage = i;
        loadCards(i, itemsPerPage, getCurrentFilters());
      });
      paginationContainer.appendChild(pageLink);
    }
  };

  const getCurrentFilters = () => {
    return Array.from(document.querySelectorAll('input[name="filter_cats"]:checked')).map(input => input.value);
  };

  const initCheckboxes = () => {
    document.querySelectorAll('input[name="filter_cats"]').forEach(input => {
      input.addEventListener('change', () => {
        currentPage = 1;
        const filterCats = getCurrentFilters();
        loadCards(currentPage, itemsPerPage, filterCats);
      });
    });
  };

  // Initiales Laden
  loadCards(currentPage, itemsPerPage, []);
  initCheckboxes();
};

export default initNewsListWithPagination;
